import { render, staticRenderFns } from "./statisticsPatients.vue?vue&type=template&id=064d8916&scoped=true"
import script from "./statisticsPatients.vue?vue&type=script&lang=js"
export * from "./statisticsPatients.vue?vue&type=script&lang=js"
import style0 from "./statisticsPatients.vue?vue&type=style&index=0&id=064d8916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d8916",
  null
  
)

export default component.exports